import Vue from 'vue'
import { compose, isNil, not } from 'ramda'

const state = {
  jwt: null,
  username: null,
  digest: null,
}

const mutations = {
  JWT_RECEIVED(state, jwt) {
    state.jwt = jwt
    localStorage.jwt = jwt
  },
  USER_DISCONNECT(state) {
    state.jwt = null
    localStorage.removeItem('jwt')
    state.username = null
    localStorage.removeItem('username')
    state.digest = null
    localStorage.removeItem('digest')
  },
  SET_USERNAME(state, username) {
    state.username = username
    localStorage.username = username
  },
  SET_DIGEST(state, digest) {
    state.digest = digest
    localStorage.digest = digest
  },
}

const actions = {
  async validate_user({ commit }, data) {
    try {
      const res = await Vue.axios.post('/auth/generate_token', data)

      if (res.status === 200) {
        commit('JWT_RECEIVED', res.data)
        commit('SET_USERNAME', data.username)
        commit('SET_DIGEST', data.digest)
        return true
      }

      return false
    }
    catch (e) {
      return false
    }
  },
}

const isDefined = compose(
  not,
  isNil
)

const getters = {
  jwt: state => state.jwt || localStorage.jwt || null,
  isLogged(state) {
    const jwt = state.jwt || localStorage.jwt || null
    return isDefined(jwt)
  },
  getUsername: state => state.username || localStorage.username || null,
  getDigest: state => state.digest || localStorage.digest || null,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
